<div class="flex flex-col items-center justify-center text-center rounded-lg border border-dashed border-border bg-surface py-20 px-6">
  <div class="w-12 h-12 rounded-full bg-brand-light flex items-center justify-center text-brand text-section-title">
    ⏳
  </div>
  <h2 class="mt-4 text-section-title text-ink-primary">{{ pageLabel() }} is coming soon</h2>
  <p class="mt-1.5 max-w-sm text-[13px] text-ink-secondary">
    This section is on the build roadmap and hasn't been implemented yet. Check back soon.
  </p>
</div>
